import { render, staticRenderFns } from "./TipsAndTricks.vue?vue&type=template&id=660521cc"
import script from "./TipsAndTricks.vue?vue&type=script&lang=js"
export * from "./TipsAndTricks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports